import { Directive } from '@angular/core';

@Directive({
  selector: '[appAutocompleteOption]',
})
export class AutocompleteOptionDirective {
}
